/**
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 */

export default [
  {
    label: 'Email',
    field_name: 'email',
    source_field: 'email',
    customClass: 'email',
    showColumn: true,
    pinned: true,
  },
  {
    label: 'First Name',
    field_name: 'first_name',
    source_field: 'first_name',
    showColumn: true,
    pinned: true,
  },
  {
    label: 'Last Name',
    field_name: 'last_name',
    source_field: 'last_name',
    showColumn: false,
    pinned: true,
  },
  {
    label: 'Phone Number',
    field_name: 'phone',
    source_field: 'phone_number',
    showColumn: false,
    suppressSorting: true,
  },
  {
    label: 'Feature Group',
    field_name: 'group_name',
    source_field: 'group_name',
    showColumn: true,
  },
  {
    label: 'Current Level',
    field_name: 'current_level_name',
    source_field: 'current_level_name',
    showColumn: true,
  },
  {
    label: 'Last Login',
    field_name: 'last_login',
    source_field: 'last_login',
    type: 'date',
    showColumn: true,
  },
  {
    label: 'Last Active',
    field_name: 'last_active_date',
    source_field: 'last_active_date',
    type: 'date',
    showColumn: true,
  },
  {
    label: 'Date Joined',
    field_name: 'date_joined',
    source_field: 'date_joined',
    type: 'date',
    showColumn: true,
  },
  {
    label: 'Membership Start Date',
    field_name: 'group_membership_start_date',
    source_field: 'group_membership_start_date',
    type: 'date',
    showColumn: false,
  },
  {
    label: 'Membership End Date',
    field_name: 'membership_end_date',
    source_field: 'membership_end_date',
    type: 'date',
    showColumn: false,
  },
  {
    label: 'External ID',
    field_name: 'external_user_id',
    source_field: 'external_user_id',
    showColumn: true,
  },
  {
    label: 'Credits Used',
    field_name: 'tutoring_credits_used',
    source_field: 'tutoring_credits_used',
    showColumn: false,
  },
  {
    label: 'Credits Available',
    field_name: 'tutoring_credits_available',
    source_field: 'tutoring_credits_available',
    showColumn: false,
  },
  {
    label: 'Purchased Credits Available',
    field_name: 'purchased_tutoring_credits_available',
    source_field: 'purchased_tutoring_credits_available',
    showColumn: false,
  },
  {
    label: 'Membership Credits Available',
    field_name: 'membership_tutoring_credits_available',
    source_field: 'membership_tutoring_credits_available',
    showColumn: false,
  },
  {
    label: 'Private Class Hours Available',
    field_name: 'private_class_hours_available',
    source_field: 'private_class_hours_available',
    showColumn: false,
  },
  {
    label: 'Private Class Hours Spent',
    field_name: 'private_class_hours_spent',
    source_field: 'private_class_hours_spent',
    showColumn: false,
  },
  {
    label: 'Country',
    field_name: 'country',
    source_field: 'country',
    showColumn: false,
  },
  {
    label: 'Native Language',
    field_name: 'native_language',
    source_field: 'native_language',
    showColumn: false,
  },
  {
    label: 'Engagement Level',
    field_name: 'engagement_level',
    source_field: 'engagement_level',
    type: 'engagement',
    showColumn: false,
  },
  {
    label: 'Activities Completed',
    field_name: 'total_activities_completed',
    source_field: 'total_activities_completed',
    showColumn: false,
  },
  {
    label: 'Total Time Studied',
    field_name: 'total_minutes_studied',
    source_field: 'total_minutes_studied',
    type: 'time',
    showColumn: false,
  },
  {
    label: 'Time in Group Classes',
    field_name: 'total_minutes_in_group_classes',
    source_field: 'total_minutes_in_group_classes',
    type: 'time',
    showColumn: false,
  },
  {
    label: 'Time in Private Classes',
    field_name: 'total_minutes_in_private_classes',
    source_field: 'total_minutes_in_private_classes',
    type: 'time',
    showColumn: false,
  },
  {
    label: 'Time in Lessons',
    field_name: 'total_minutes_in_lessons',
    source_field: 'total_minutes_in_lessons',
    type: 'time',
    showColumn: false,
  },
  {
    label: 'Time in VPA',
    field_name: 'total_minutes_in_vpa',
    source_field: 'total_minutes_in_vpa',
    type: 'time',
    showColumn: false,
  },
  {
    label: 'Time in Word Bank',
    field_name: 'total_minutes_in_word_bank',
    source_field: 'total_minutes_in_word_bank',
    type: 'time',
    showColumn: false,
  },
  {
    label: 'Time in Grammar Guide',
    field_name: 'total_minutes_in_grammar_guide',
    source_field: 'total_minutes_in_grammar_guide',
    type: 'time',
    showColumn: false,
  },
  {
    label: "Number of VPA's Completed",
    field_name: 'number_vpas_completed',
    source_field: 'number_vpas_completed',
    showColumn: false,
  },
  {
    label: 'First VPA Level',
    field_name: 'first_vpa_level',
    source_field: 'first_vpa_level',
    showColumn: false,
  },
  {
    label: 'Last VPA Level',
    field_name: 'last_vpa_level',
    source_field: 'last_vpa_level',
    showColumn: false,
  },
  {
    label: 'Next VPA Date',
    field_name: 'next_vpa_date',
    source_field: 'next_vpa_date',
    type: 'date',
    showColumn: false,
  },
  {
    label: 'First VPA Date',
    field_name: 'first_vpa_date',
    source_field: 'first_vpa_date',
    type: 'date',
    showColumn: false,
  },
  {
    label: 'Last VPA Date',
    field_name: 'last_vpa_date',
    source_field: 'last_vpa_date',
    type: 'date',
    showColumn: false,
  },
  {
    label: 'First VPA Score',
    field_name: 'first_vpa_score_total_adjusted',
    source_field: 'first_vpa_score_total_adjusted',
    type: 'score',
    showColumn: false,
  },
  {
    label: 'Last VPA Score',
    field_name: 'last_vpa_score_total_adjusted',
    source_field: 'last_vpa_score_total_adjusted',
    type: 'score',
    showColumn: false,
  },
  {
    label: 'Number of Group Classes',
    field_name: 'total_number_of_group_classes',
    source_field: 'total_number_of_group_classes',
    showColumn: false,
  },
  {
    label: 'Number of Private Classes',
    field_name: 'total_number_of_private_classes',
    source_field: 'total_number_of_private_classes',
    showColumn: false,
  },
  {
    label: 'Grammar Performance',
    field_name: 'grammar_score',
    source_field: 'grammar_score',
    type: 'percentage',
    showColumn: false,
  },
  {
    label: 'Listening Performance',
    field_name: 'listening_score',
    source_field: 'listening_score',
    type: 'percentage',
    showColumn: false,
  },
  {
    label: 'Reading Performance',
    field_name: 'reading_score',
    source_field: 'reading_score',
    type: 'percentage',
    showColumn: false,
  },
  {
    label: 'Speaking Performance',
    field_name: 'speaking_score',
    source_field: 'speaking_score',
    type: 'percentage',
    showColumn: false,
  },
  {
    label: 'Vocabulary Performance',
    field_name: 'vocabulary_score',
    source_field: 'vocabulary_score',
    type: 'percentage',
    showColumn: false,
  },
  {
    label: 'Writing Performance',
    field_name: 'writing_score',
    source_field: 'writing_score',
    type: 'percentage',
    showColumn: false,
  },
  {
    label: 'Learning Language',
    field_name: 'learning_language_id',
    source_field: 'learning_language_id',
    showColumn: true,
  },
];
